module.exports = new __parcel__URL__("iron-man.0573953a.jpg").toString();